import React from "react";
import vorstandData from "../data/vorstandData";
import PageWrapper from "../components/PageWrapper";

const Vorstand = () => {
  return (
    <PageWrapper>
      <main>
        <section
          className="py-12 sm:py-16 min-h-screen"
          style={{
            backgroundImage: `url('/gradient_bg.svg'), linear-gradient(to bottom, #d0eefb, #ffffff 50%, #ffffff)`,
            backgroundRepeat: "no-repeat, no-repeat",
            backgroundSize: "cover, cover",
            backgroundPosition: "center, center",
          }}
          aria-labelledby="vorstand-heading"
        >
          <div className="mx-auto max-w-6xl lg:max-w-6xl px-6 sm:px-6 lg:px-4">
            <header className="mb-12">
              <h1
                id="vorstand-heading"
                className="text-left text-base font-semibold text-sky-600 font-heading"
              >
                Vorstand
              </h1>
              <h2 className="mt-2 text-left text-2xl font-semibold tracking-tight text-gray-950 font-heading">
                Wir stellen uns vor
              </h2>
              <p className="mt-6 text-base text-gray-700 font-body sm:text-lg">
                {vorstandData.intro}
              </p>
            </header>

            <section
              className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6"
              aria-label="Vorstandsmitglieder"
            >
              {vorstandData.members.map((member) => (
                <figure
                  key={member.name}
                  className="flex flex-col h-full"
                >
                  <div className="flex flex-col flex-grow bg-white shadow-md border border-gray-200 p-3 pb-6 w-full">
                    <div className="w-full aspect-square overflow-hidden">
                      <img
                        className="w-full h-full object-cover"
                        src={member.image}
                        alt={`Portrait von ${member.name}, ${member.role}`}
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/placeholder-profile.png";
                          e.target.alt = `Platzhalterbild für ${member.name}`;
                        }}
                      />
                    </div>
                    <figcaption className="mt-3 text-center flex flex-col flex-grow justify-end">
                      <h3 className="text-base font-semibold text-gray-900 font-heading">
                        {member.name}
                      </h3>
                      <p className="text-sm font-semibold text-sky-600 font-heading">
                        {member.role}
                      </p>
                    </figcaption>
                  </div>
                </figure>
              ))}
            </section>


          </div>
        </section>
      </main>
    </PageWrapper>
  );
};

export default Vorstand;